'use strict';

var React = require('react');
var FormatMessage = require('react-globalize').FormatMessage;
var Globalize = require('globalize');
// var Select = require('react-select');
import Select from 'react-select';

var geocoder;
var map = null;
var markers = [];
var selectedItem;
var directionsService;
var directionsDisplay;
var iw;
var gmarker;
var latlngbounds;
var mapOptions = {};
var lastRequestTime = 0;





var BfgLocationMap = React.createClass({

  getInitialState: function () {

    return {
      lat: null, lng: null, latDest: null, lngDest: null, selectedMode: 'DRIVING',
      extScript: null
    }
  },

  hideShowComponents: function (val) {
    $('.input-group').removeClass("has-error");
    $("#errorBox").hide(100);
    $("#errorStoreType").hide(100);

    if (val == true) {
      $('#floating-panel').show();
    } else {
      $('#floating-panel').hide();
    }
  },

  requestTime: function (inter) {
    var now = Date.now();
    if (lastRequestTime + inter < now) {
      lastRequestTime = now;
      return true;
    } else
      return false;
  },

  findStoresByLoc: function (lat, lng) {

    if (lat != null && lng != null) {
      $('#storesList').empty();
      var latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };
      var state = "";
      var self = this;

      geocoder.geocode({ 'location': latlng }, function (results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          var result = results[5].formatted_address.split(",");
          state = result[1];

        }
        let tState = self.getStateFromGeocodeResponse(results) || "Tx";

        var url = '/findLocation/' + lng + '/' + lat + '/' + tState.short_name;

        $.ajax({
          url: url,
          type: 'get',
          dataType: "json",
          success: function (bfgData, e) {
            self.fillStoreList(bfgData, lat, lng);
            var latlng = new google.maps.LatLng(lat, lng);
            var oIcon = 'https://maps.google.com/mapfiles/ms/icons/blue-pushpin.png';
            gmarker.setPosition({ lat: lat, lng: lng });
            gmarker.setVisible(true);
            // gmarker = new google.maps.Marker({
            //   map: map,
            //   position: latlng,
            //   title: 'My Location',
            //   icon: oIcon
            // });
            //self.clearMarkers();
            //markers.push(gmarker);
            map.setCenter({ lat: lat, lng: lng });
          },
          error: function (xhr, status, error) {
            var lisItems = [];
            lisItems.push('<div style="margin-right:12px" class="alert alert-warning" role="alert"><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span> No data found.</div>');
            $('#storesList').empty();
            $('#storesList').append(lisItems[0]);
          }
        });// ajax
      });
    }
  },

  getStateFromGeocodeResponse: function (response) {
    let valid;
    for (var index = 0; index < response.length; index++) {
      var element = response[index];
      if (element.types[0] == "locality") {
        valid = element;
        break;
      }
    }
    for (var index = 0; index < valid.address_components.length; index++) {
      var element = valid.address_components[index];
      if (element.types[0] == "administrative_area_level_1") {
        return element;
      }
    }
    console.warn("Can't get the locality");
    return null;
  },

  findStoresByParams: function (lat, lng, params) {

    if (lat != null && lng != null) {
      $('#storesList').empty();
      var url = '/findLocByParams/' + lng + '/' + lat + '/' + params.zip + '/' + params.city + '/' + params.state + '/' + params.address;
      var self = this;
      $.ajax({
        url: url,
        type: 'get',
        dataType: "json",
        success: function (bfgData, e) {

          self.fillStoreList(bfgData, lat, lng);
          //var latlng = new google.maps.LatLng(lat,lng);
          //var oIcon = 'https://maps.google.com/mapfiles/ms/icons/blue-pushpin.png';
          // var marker = new google.maps.Marker({
          //     map: map,
          //     position: latlng,
          //     title: 'My Location'
          // });
          // markers.push(marker);
        },
        error: function (xhr, status, error) {
          var lisItems = [];
          lisItems.push('<div style="margin-right:12px" class="alert alert-warning" role="alert"><span class="glyphicon glyphicon-info-sign" aria-hidden="true"></span> No data found.</div>');
          $('#storesList').empty();
          $('#storesList').append(lisItems[0]);
        }
      });// ajax

    }
  },

  findStores: function (params, latitude, longitude) {

    if (params != null) {
      $('#storesList').empty();
      var url = '/findLocationByZip/' + params.zip + '/' + params.city + '/' + params.state + '/' + params.address;
      var self = this;
      $.ajax({
        url: url,
        type: 'get',
        dataType: "json",
        success: function (bfgData, e) {
          self.findStoresByParams(latitude, longitude, params);

        },
        error: function (xhr, status, error) {
          var lisItems = [];
          lisItems.push('<div style="margin-right:12px" className="alert alert-warning" role="alert"><span className="glyphicon glyphicon-info-sign" aria-hidden="true"></span> No data found.</div>');
          $('#storesList').empty();
          $('#storesList').append(lisItems[0]);
        }

      });// ajax
    }
  },

  fillStoreList: function (bfgData, lat, lng) {
    console.log('fillStoreList: ', lng, lat, bfgData);
    this.clearMarkers();
    var lisItems = [];

    if (bfgData.length == 0) {
      lisItems.push('<div style="margin-right:12px" className="alert alert-warning" role="alert"><span className="glyphicon glyphicon-info-sign" aria-hidden="true"></span> No se encontraron tiendas Barri para esa localizacion.</div>');
      $('#storesList').append(lisItems[0]);
      map.setCenter({ lat: lat, lng: lng });
      //map.fitBounds(latlngbounds);

    } else {

      lisItems.push("<ul class='list-unstyled'>");
      lisItems.push("<ul class='list-unstyled' style='cursor:pointer'>");
      for (var i = 0; i < bfgData.length; i++) {
        var bfgS = bfgData[i];
        var oIcon = 'https://maps.google.com/mapfiles/ms/icons/red-dot.png';
        var iwData = "";

        if (bfgS.type == 'Agent') {
          oIcon = 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png'
          iwData = '<div id="locationContent">' +
            '<table>' +
            '<tr><td><strong>Description: </strong></td><td>' + bfgS.description + '</td></tr>' +
            '<tr align="left"><td><strong>Address: </strong></td><td>' + bfgS.address + ',' + bfgS.city + ',' + bfgS.state + ',' + bfgS.zip + '</td></tr>' +
            '</table>' +
            '</div>';

          lisItems.push('<li id= "' + bfgS.code + '" ><div   class="divList"><p class="location-map"><strong>' + bfgS.description +
            '</strong></p>' + '<p class="location-map">' + bfgS.address + ', ' + bfgS.city + ', ' + bfgS.state + ', ' + bfgS.zip + '</p>' +
            '</p></div>' + '<a className= "goTo" style= "cursor:pointer" id="' + bfgS.latitude + '/' + bfgS.longitude + '"><strong>Get Directions</strong></a>' +
            '</li>');
        } else if (bfgS.has_loans === '0') {
          oIcon = 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png';
        } else if (bfgS.has_loans === "1") {
          oIcon = 'https://maps.google.com/mapfiles/ms/icons/purple-dot.png';
        } else if (bfgS.type == 'Corporate') {
          oIcon = 'https://maps.google.com/mapfiles/ms/icons/green-dot.png';
        }
        if (bfgS.estatus == 'Suspended') {
          oIcon = 'https://maps.google.com/mapfiles/ms/icons/red-dot.png';
        }

        if (bfgS.type != 'Agent') {
          iwData = '<div id="locationContent">' +
            '<table>' +
            '<tr><td><strong>Description: </strong></td><td>' + bfgS.description + '</td></tr>' +
            '<tr align="left"><td><strong>Address: </strong></td><td>' + bfgS.address + ',' + bfgS.city + ',' + bfgS.state + ',' + bfgS.zip + '</td></tr>' +
            '<tr align="left"><td><strong>Phone: </strong></td><td>' + bfgS.phone1 + '</td></tr>' +
            '</table>' +
            '</div>';

          lisItems.push('<li id= "' + bfgS.code + '" ><div   class="divList"><p class="location-map"><strong>' + bfgS.description +
            '</strong></p>' + '<p class="location-map">' + bfgS.address + ', ' + bfgS.city + ', ' + bfgS.state + ', ' + bfgS.zip + '</p>' +
            '<p class="location-map">' + bfgS.phone1 + '</p></div>' + '<a className= "goTo" style= "cursor:pointer" id="' + bfgS.latitude + '/' + bfgS.longitude + '"><strong>Get Directions</strong></a>' +
            '</li>');
        }

        var latlng = new google.maps.LatLng(bfgS.latitude, bfgS.longitude);

        var marker = new google.maps.Marker({
          map: map,
          position: latlng,
          title: bfgS.description,
          icon: oIcon
        });
        marker["bfgcode"] = bfgS.code;
        marker["bfgtype"] = bfgS.type.toUpperCase();
        marker["bfgcity"] = bfgS.city.toUpperCase();
        marker["bfgstate"] = bfgS.state.toUpperCase();
        marker["bfgzip"] = bfgS.zip.toUpperCase();
        marker["bfgdescription"] = bfgS.description.toUpperCase();
        marker["bfgaddress"] = bfgS.address.toUpperCase() + ' TEST';

        this.addIW(map, marker, iwData);
        markers.push(marker);
        latlngbounds.extend(marker.position);
      } // for

      lisItems.push("</ul>");
      $('#storesList').append(lisItems.join(""));

      map.setCenter(latlngbounds.getCenter());

      map.fitBounds(latlngbounds);
    }
  },

  findCenterPoint: function (bfgData, params) {

    var bound = new google.maps.LatLngBounds();

    for (var i = 0; i < bfgData.length; i++) {
      var bfgS = bfgData[i];
      var latlng = new google.maps.LatLng(bfgS.latitude, bfgS.longitude);
      bound.extend(new google.maps.LatLng(bfgS.latitude, bfgS.longitude));
    }

    this.findStoresByParams(bound.getCenter().lat(), bound.getCenter().lng(), params);

  },

  clearMarkers: function () {
    latlngbounds = new google.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
      markers[i].setMap(null);
    }
    markers = [];
  },

  refreshMarkers: function (code) {
    latlngbounds = new google.maps.LatLngBounds();
    for (var i = 0; i < markers.length; i++) {
      if (markers[i].bfgcode == code) {
        markers[i].setVisible(true);
      } else {
        markers[i].setVisible(false);
      }
      if (markers[i].visible == true) {
        latlngbounds.extend(markers[i].position);
      }
    }
    map.fitBounds(latlngbounds);
    map.setCenter(latlngbounds.getCenter());
    var listener = google.maps.event.addListener(map, "idle", function () {
      if (map.getZoom() > 14) map.setZoom(14);
      google.maps.event.removeListener(listener);
    });
  },

  refreshMarkersByStoreType: function (storeType) {
    var self = this;
    var searchTerm = null;
    var arrST = null;
    var arrF = null;
    var visibleList = [];

    gmarker.setVisible(true);
    latlngbounds = new google.maps.LatLngBounds();
    latlngbounds.extend(gmarker.position);

    for (var i = 0; i < markers.length; i++) {
      if (storeType == 'ALL') {
        //markers[i].setVisible(true);
        visibleList.push(i);
      } else {
        if (storeType.toUpperCase() == markers[i].bfgtype) {
          //markers[i].setVisible(true);
          visibleList.push(i);
        }
      }
    }
    if (visibleList.length > 0) {

      for (var j = 0; j < markers.length; j++) {

        if ($.inArray(j, visibleList) >= 0) {

          markers[j].setVisible(true);
          latlngbounds.extend(markers[j].position);
        } else {

          markers[j].setVisible(false);
        }

      }

      map.setCenter(latlngbounds.getCenter());
      map.fitBounds(latlngbounds);

      var listener = google.maps.event.addListener(map, "idle", function () {
        if (map.getZoom() > 14) map.setZoom(14);
        google.maps.event.removeListener(listener);
      });
    } else {
      $('#storeType').val("ALL");
      $("#errorStoreType").show(100);
      $("#errorStoreType").removeAttr("hidden");
      for (var j = 0; j < markers.length; j++) {
        markers[j].setVisible(true);
        latlngbounds.extend(markers[j].position);
      }

      map.setCenter(latlngbounds.getCenter());
      map.fitBounds(latlngbounds);

      var listener = google.maps.event.addListener(map, "idle", function () {
        if (map.getZoom() > 14) map.setZoom(14);
        google.maps.event.removeListener(listener);
      });

    }
  },

  getLocation: function () {

    var self = this;
    if (!navigator.geolocation) {
      output.innerHTML = "<p>Geolocation is not supported by your browser</p>";
      return;
    }
    function success(position) {
      var lat = position.coords.latitude;
      var lng = position.coords.longitude;
      self.findStoresByLoc(lat, lng);
    }
    function error() {
      var lisItems = [];
      lisItems.push('<div style="margin-right:12px" className="alert alert-warning" role="alert"><span className="glyphicon glyphicon-info-sign" aria-hidden="true"></span> Unable to retrieve your location.</div>');
      $('#storesList').empty();
      $('#storesList').append(lisItems[0]);
      map.setCenter(latlngbounds.getCenter());
      map.fitBounds(latlngbounds);

    }
    navigator.geolocation.getCurrentPosition(success, error);
  },

  removeRoutes: function () {
    if (directionsDisplay != null) {
      directionsDisplay.set('directions', null);
    }
  },

  calculateAndDisplayRoute: function (modeValue) {

    if (this.state.lat != null && this.state.lng != null) {

      //var selectedMode = this.state.selectedMode;
      gmarker.setVisible(false);
      directionsService.route({
        origin: { lat: this.state.lat, lng: this.state.lng },
        destination: {
          lat: parseFloat(this.state.latDest),
          lng: parseFloat(this.state.lngDest)
        },
        travelMode: google.maps.TravelMode[modeValue]
      },
        function (response, status) {
          if (status === google.maps.DirectionsStatus.OK) {
            directionsDisplay.setDirections(response);
          }
        });
    }

  },

  addIW: function (map, marker, iwData) {
    google.maps.event.addListener(marker, 'click', function () {
      iw.setContent(iwData);
      iw.open(map, this);
    });
  },

  codeAddress: function () {
    var address = document.getElementById('address').value;
    geocoder.geocode({ 'address': address }, function (results, status) {
      if (status == google.maps.GeocoderStatus.OK) {
        var loc = document.getElementById('location-info');
        loc.innerHTML = "<p>Location data: " + results[0].geometry.location + "</>";
        map.setCenter(results[0].geometry.location);
        var marker = new google.maps.Marker({
          map: map,
          position: results[0].geometry.location
        });
      }
    });
  },

  handleModeChange: function (newValue) {

    var mode = newValue;
    this.setState({
      selectedMode: newValue
    });
    this.calculateAndDisplayRoute(newValue);

  },

  componentDidMount() {

    var self = this;

    $("#findStores").on("click", function () {

      self.removeRoutes();

      setTimeout(function () {
        self.hideShowComponents(false);
      }, 5000);

      $('.input-group').removeClass("has-error");
      $("#errorBox").hide(100);
      var v = $('#pac-input').val();
      $('#storeType').val("ALL");

      self.findStores(v);
      $('#pac-input').val("");
    });

    $("#btnFindByLocation").on("click", function () {
      self.removeRoutes();
      self.hideShowComponents(false);
      $('.input-group').removeClass("has-error");
      $("#errorBox").hide(100);
      $('#pac-input').val("");
      $('#storeType').val("ALL");
      if ("geolocation" in navigator) {
        self.getLocation();
      } else {
        $("#errorBox").show(100);
        $("#errorMessage").text(Globalize(self.props.locale).messageFormatter('locationsPage/notSupportLocation')());
      }
    });

    $("#storeType").on("change", function () {
      self.removeRoutes();
      self.hideShowComponents(false);
      $('.input-group').removeClass("has-error");
      $("#errorBox").hide(100);
      $('#pac-input').val("");

      var storeType = $('#storeType').val();
      self.refreshMarkersByStoreType(storeType);

    });

    //This method is called for Store click
    $("#storesList").on("click", ".divList", function () {

      $('.input-group').removeClass("has-error");
      $("#errorStoreType").hide(100);

      if (self.requestTime(600)) {
        self.hideShowComponents(false);
        $('#pac-input').val("");
        $(selectedItem).removeClass("selected");
        selectedItem = $(this).parent();
        $(selectedItem).addClass("selected");
        self.refreshMarkers(selectedItem[0].id);
        self.removeRoutes();
      }
    });

    //This method is called for Get Directions
    $("#storesList").on("click", "a", function (e) {

      if (self.requestTime(600)) {
        self.hideShowComponents(true);
        self.state.selectedMode = 'DRIVING';
        $('#pac-input').val("");
        $('#selectedMode').val('DRIVING');
        $(selectedItem).removeClass("selected");
        selectedItem = $(this).parent();
        $(selectedItem).addClass("selected");
        self.refreshMarkers(selectedItem[0].id);
        self.removeRoutes();
        e.preventDefault();
        var coords = $(this)[0].id;
        var destCoords = coords.split("/");
        self.setState({ latDest: destCoords[0], lngDest: destCoords[1] });
        self.calculateAndDisplayRoute('DRIVING');
      }
    });

    $("#pac-input").keypress(function (e) {
      $('#floating-panel').hide();
      if (e.which == 13) {
        e.preventDefault();
        $("#findStores").click();
      }
    });
    //google.maps.event.addDomListener(window, 'page:load', this.initialize);
    if (this.props.loaded) {
      this.initialize();
      this.setState({
        initialized: true
      })
    }
  },

  componentWillReceiveProps(nextProps) {
    if (nextProps.loaded && !this.state.initialized) {
      this.initialize();
      this.setState({
        initialized: true
      })
    }
  },
  // initializeOld: function () {

  //   iw = new google.maps.InfoWindow();
  //   geocoder = new google.maps.Geocoder();
  //   directionsService = new google.maps.DirectionsService;

  //   var latlng = new google.maps.LatLng(29.68, -95.52);
  //   mapOptions = {
  //     zoom: 14,
  //     center: latlng
  //   }

  //   var styles = {
  //     default: null,
  //     hide: [
  //       {
  //         featureType: 'poi.business',
  //         stylers: [{ visibility: 'off' }]
  //       }
  //     ]
  //   };

  //   map = new google.maps.Map(document.getElementById('map-canvas'), mapOptions);
  //   map.setOptions({ styles: styles['hide'] });


  //   directionsDisplay = new google.maps.DirectionsRenderer;
  //   directionsDisplay.setMap(map);

  //   gmarker = new google.maps.Marker({
  //     map: map,
  //     anchorPoint: new google.maps.Point(-95.54, 29.69)
  //   });

  //   var input = (document.getElementById('pac-input'));
  //   var autocomplete = new google.maps.places.Autocomplete(input);
  //   autocomplete.bindTo('bounds', map);

  //   latlngbounds = new google.maps.LatLngBounds();

  //   var self = this;

  //   google.maps.event.addListener(autocomplete, 'place_changed', function () {
  //     iw.close();
  //     gmarker.setVisible(false);
  //     self.removeRoutes();
  //     var place = autocomplete.getPlace();
  //     if (!place.geometry) {
  //       return;
  //     }

  //     if (place.geometry.viewport) {
  //       map.fitBounds(place.geometry.viewport);
  //     } else {
  //       map.setCenter(place.geometry.location);
  //       map.setZoom(17);
  //     }

  //     gmarker.setPosition(place.geometry.location);
  //     //gmarker.setVisible(true);

  //     if (place.address_components) {
  //       var i = 0;
  //       var address;
  //       var city;
  //       var state;
  //       var country;
  //       var zip;
  //       for (i = 0; i < place.address_components.length; i++) {
  //         if (place.address_components[i].types[0] == 'street_number') {
  //           address = place.address_components[i].long_name;
  //         }
  //         if (place.address_components[i].types[0] == 'route') {
  //           address += ' ' + place.address_components[i].long_name;
  //         }
  //         if (place.address_components[i].types[0] == 'locality') {
  //           city = place.address_components[i].long_name;
  //         }
  //         if (place.address_components[i].types[0] == 'administrative_area_level_1') {
  //           state = place.address_components[i].long_name;
  //         }
  //         if (place.address_components[i].types[0] == 'country') {
  //           country = place.address_components[i].long_name;
  //         }
  //         if (place.address_components[i].types[0] == 'postal_code') {
  //           zip = place.address_components[i].long_name;
  //         }
  //       }
  //       var searchText = { address: address, city: city, state: state, zip: zip };
  //       var latitude = place.geometry.location.lat();
  //       var longitude = place.geometry.location.lng();
  //       //self.findStoresByLoc(latitude, longitude);
  //       self.findStores(searchText, latitude, longitude);
  //     }
  //   });

  //   navigator.geolocation.getCurrentPosition(function (position) {
  //     //let lat = position.coords.latitude;
  //     self.setState({ lat: position.coords.latitude, lng: position.coords.longitude });
  //     self.findStoresByLoc(position.coords.latitude, position.coords.longitude);
  //   }, function () {
  //     var lisItems = [];
  //     lisItems.push('<div style="margin-right:12px" className="alert alert-warning" role="alert"><span className="glyphicon glyphicon-info-sign" aria-hidden="true"></span>' + Globalize(self.props.locale).messageFormatter('locationsPage/notSupportLocation')() + '.</div>');
  //     $('#storesList').empty();
  //     $('#storesList').append(lisItems[0]);
  //   });

  //   this.hideShowComponents(false);

  // }, // initialize()

  initialize() {
    let self = this;
    iw = new google.maps.InfoWindow();
    geocoder = new google.maps.Geocoder();

    var texas = { lat: 31.000, lng: -100.000 };
    map = new google.maps.Map(document.getElementById('map-canvas'), {
      zoom: 7,
      center: texas
    });

    var input = (document.getElementById('pac-input'));
    var autocomplete = new google.maps.places.Autocomplete(input);
    autocomplete.bindTo('bounds', map);
    directionsService = new google.maps.DirectionsService;
    directionsDisplay = new google.maps.DirectionsRenderer;
    directionsDisplay.setMap(map);
    var oIcon = 'https://maps.google.com/mapfiles/ms/icons/blue-pushpin.png';

    gmarker = new google.maps.Marker({
      map: map,
      //position: uluru,
      title: 'My Location',
      icon: oIcon
    });

    this.addMapAutocompleteListener(autocomplete, gmarker);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        //let lat = position.coords.latitude;
        self.setState({ lat: position.coords.latitude, lng: position.coords.longitude });
        uluru = { lat: position.coords.latitude, lng: position.coords.longitude };

        //map.setCenter(uluru);
        self.findStoresByLoc(position.coords.latitude, position.coords.longitude);

      }, function () {
        var lisItems = [];
        lisItems.push('<div style="margin-right:12px" className="alert alert-warning" role="alert"><span className="glyphicon glyphicon-info-sign" aria-hidden="true"></span>' + Globalize(self.props.locale).messageFormatter('locationsPage/notSupportLocation')() + '.</div>');
        $('#storesList').empty();
        $('#storesList').append(lisItems[0]);
        console.warn("Your Browser does not support geolocalization II");
      });
    } else {
      var lisItems = [];
      lisItems.push('<div style="margin-right:12px" className="alert alert-warning" role="alert"><span className="glyphicon glyphicon-info-sign" aria-hidden="true"></span>' + Globalize(self.props.locale).messageFormatter('locationsPage/notSupportLocation')() + '.</div>');
      $('#storesList').empty();
      $('#storesList').append(lisItems[0]);
      console.warn("Your Browser does not support geolocalization");
    }
    this.hideShowComponents(false);
  },

  addMapAutocompleteListener(autocomplete, gmarker) {
    let self = this;
    google.maps.event.addListener(autocomplete, 'place_changed', function () {
      iw.close();
      gmarker.setVisible(false);
      self.removeRoutes();
      var place = autocomplete.getPlace();
      if (!place.geometry) {
        return;
      }

      if (place.geometry.viewport) {
        map.fitBounds(place.geometry.viewport);
      } else {
        map.setCenter(place.geometry.location);
        map.setZoom(17);
      }

      gmarker.setPosition(place.geometry.location);
      gmarker.setVisible(true);

      if (place.address_components) {
        var i = 0;
        var address;
        var city;
        var state;
        var country;
        var zip;
        for (i = 0; i < place.address_components.length; i++) {
          if (place.address_components[i].types[0] == 'street_number') {
            address = place.address_components[i].long_name;
          }
          if (place.address_components[i].types[0] == 'route') {
            address += ' ' + place.address_components[i].long_name;
          }
          if (place.address_components[i].types[0] == 'locality') {
            city = place.address_components[i].long_name;
          }
          if (place.address_components[i].types[0] == 'administrative_area_level_1') {
            state = place.address_components[i].long_name;
          }
          if (place.address_components[i].types[0] == 'country') {
            country = place.address_components[i].long_name;
          }
          if (place.address_components[i].types[0] == 'postal_code') {
            zip = place.address_components[i].long_name;
          }
        }
        var searchText = { address: address, city: city, state: state, zip: zip };
        var latitude = place.geometry.location.lat();
        var longitude = place.geometry.location.lng();
        //self.findStoresByLoc(latitude, longitude);
        self.findStores(searchText, latitude, longitude);
      }
    });
  },

  componentWillMount() {
    // this.setState({
    //   extScript: this.getExternalScript()
    // })
  },


  render: function () {
    return (
      <div>

        <div className="container-fluid">



          <form id="myForm">
            <div className="row">
              <div className="col-xs-12 col-md-6">
                <div className="alert alert-danger" id="errorBox" role="alert" hidden="true">
                  <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                  <label className="errorMessage" id="errorMessage"></label>
                </div>
              </div>
            </div>

            <div className="row">

              <div className="col-xs-12 col-md-4 form-group">
                <div className="input-group ">
                  <span className="input-group-addon" id="basic-addon1">
                    <span className="glyphicon glyphicon-search" aria-hidden="true"></span></span>
                  <input className="form-control" type="text" id="pac-input" maxLength="30"
                    placeholder={Globalize(this.props.locale).messageFormatter('locationsPage/textToSearch')()} aria-describedby="basic-addon1" />
                </div>
              </div>
              <div className="col-xs-12 col-md-3 form-group">
                <button id="btnFindByLocation" type="button" className="btn btn-primary">
                  <i className="fa fa-thumb-tack" aria-hidden="true"></i> <FormatMessage locale={this.props.locale} path="locationsPage/btnMyLocation" />
                </button>
              </div>
            </div>


            <div className="panel panel-default marginPanel">
              <div className="panel-body">
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <p id="pStyle"><FormatMessage locale={this.props.locale} path="locationsPage/storeList" /></p>
                  </div>
                  <div className="col-xs-12 col-md-8">
                    <div className="col-xs-12 col-md-6 storeType">
                      <FormatMessage locale={this.props.locale} path="locationsPage/storeType" />
                    </div>
                    <div className="col-xs-12 col-md-6">
                      <select className="form-control" id="storeType" name="storeType" placeholder="select">
                        <option value="ALL">{Globalize(this.props.locale).messageFormatter('locationsPage/allStore')()}</option>
                        <option value="BMS Branch">{Globalize(this.props.locale).messageFormatter('locationsPage/BMS')()}</option>
                        <option value="HLC Branch">{Globalize(this.props.locale).messageFormatter('locationsPage/HLC')()}</option>
                        <option value="Agent">{Globalize(this.props.locale).messageFormatter('locationsPage/agent')()}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12 col-md-4">{' '}</div>
                  <div className="col-xs-12 col-md-8">
                    <div className="alert alert-danger" id="errorStoreType" role="alert" hidden="true">
                      <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
                      <label className="errorMessage"><FormatMessage locale={this.props.locale} path="locationsPage/notFoundStores" /></label>
                    </div>
                  </div>
                </div>
                {/* -----validating------ */}
                <div className="row">
                  <div className="col-xs-12 col-md-4">
                    <div id="storesList"></div>
                  </div>
                  <div className="col-xs-12 col-md-8">
                    <div id="floating-panel">

                      <div className="row">
                        <div className="col-md-3"><b>Mode:</b></div>
                        <div className="col-md-9">
                          <Select id="selectedMode"
                            ref="selectedMode"
                            name="selectedMode"
                            value={this.state.selectedMode}
                            options={[{ value: 'DRIVING', label: 'Driving' },
                            { value: 'WALKING', label: 'Walking' },
                            { value: 'BICYCLING', label: 'Bicycling' },
                            { value: 'TRANSIT', label: 'Transit' }]}
                            onChange={this.handleModeChange}
                            simpleValue clearable={false} searchable={false}
                          />
                        </div>
                      </div>
                    </div>
                    <div id="map-canvas" ></div>
                  </div>
                </div>
                {/* ---END--validating------ */}
              </div>

            </div>

          </form>

        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-2 col-sm-1 col-md-1 storeIcono"><img className="img-responsive" src="https://maps.google.com/mapfiles/ms/icons/blue-dot.png" /></div>
            <div className="col-xs-10 col-md-10 storeDescription"><span className="storeTitle"><FormatMessage locale={this.props.locale} path="locationsPage/BMS" /></span>: <FormatMessage locale={this.props.locale} path="locationsPage/BMSDescription" /></div>
          </div>
          <div className="row">
            <div className="col-xs-2 col-sm-1 col-md-1 storeIcono"><img className="img-responsive" src="https://maps.google.com/mapfiles/ms/icons/purple-dot.png" /></div>
            <div className="col-xs-10 col-md-10 storeDescription"><span className="storeTitle"><FormatMessage locale={this.props.locale} path="locationsPage/HLC" /></span>: <FormatMessage locale={this.props.locale} path="locationsPage/HLCDescription" /></div>
          </div>
          <div className="row">
            <div className="col-xs-2 col-sm-1 col-md-1 storeIcono"><img className="img-responsive" src="https://maps.google.com/mapfiles/ms/icons/yellow-dot.png" /></div>
            <div className="col-xs-10 col-md-10 storeDescription"><span className="storeTitle"><FormatMessage locale={this.props.locale} path="locationsPage/agent" /></span>: <FormatMessage locale={this.props.locale} path="locationsPage/agentDescription" /></div>
          </div>
        </div>
      </div>
    );
  }


})

module.exports = BfgLocationMap



// WEBPACK FOOTER //
// ./js/locationMap.js